const getSignature = (userName = '', companyName = '') =>
  `<p>Best,<br />${userName} | ${companyName}</p>`;

export default getSignature;
